<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Purchase Orders <button class="btn btn-success" (click)="ngOnInit();" id='btn_ok'> Refresh </button></h1>
            </div>
            <div class="col-sm-6">
                <a [routerLink]="['/app/po/']" routerLinkActive="router-link-active" ><button type="button" class="btn btn-success btn-flat">Open PO</button></a>
                <a [routerLink]="['/app/po']" routerLinkActive="router-link-active" ><button type="button" class="btn btn-success btn-flat">ALL PO</button></a>
                <a [routerLink]="['/app/po']" routerLinkActive="router-link-active" ><button type="button" class="btn btn-success btn-flat">My PO</button></a>
                <a [routerLink]="['/app/po/add']" routerLinkActive="router-link-active" ><button type="button" class="btn btn-success btn-flat">New PO</button></a>
            </div>
        </div>
    </div>
</section>


<section class="content">

    <div class="row">

        <div class="col-md-12">
            <div class="box box-info ">
            <table id="example1" class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>PO #</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Reference</th>
                        <th>Vendor</th>
                        <th>Created By</th>
                        <th>Note</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let p of pos">
                        <td><a routerLink="/app/po/{{ p.po_id }}">{{ p.po_id}}</a></td>

                        <td>{{ p.po_date}}</td>
                        <td>Draft</td>
                        <td>{{ p.reference}}</td>

                        <td><a routerLink="/app/vendor/{{ p.vendor_id }}">{{ p.vendor_name}}</a></td>
                        <td>0</td>
                        <td>3</td>
                        <td>
                            <div class="btn-group" title="View Account">
                                <a class="btn btn-primary btn-o dropdown-toggle" data-toggle="dropdown" href="#" aria-expanded="false">
                                    Action <span class="caret"></span>
                                </a>
                                <ul role="menu" class="dropdown-menu dropdown-light pull-right">
                                    <li>
                                        <a title="View Invoice" routerLink="/app/po/{{ p.po_id }}" [queryParams]="{action: 'view'}"><i class="fa fa-fw fa-eye text-blue"></i>View
                                            Purchase</a>
                                    </li>
                                    <li>
                                        <a title="Update Record ?" routerLink="/app/po/{{ p.po_id }}" [queryParams]="{action: 'edit'}">
                                            <i class="fa fa-fw fa-edit text-blue"></i>Edit
                                        </a>
                                    </li>
                                    <li>
                                        <a title="Update Record ?" routerLink="/app/po/{{ p.po_id }}" [queryParams]="{action: 'print'}">
                                            <i class="fa fa-fw fa-print text-blue"></i>Print
                                        </a>
                                    </li>
                                    <li>
                                        <a title="Update Record ?" routerLink="/app/po/{{ p.po_id }}" [queryParams]="{action: 'return'}">
                                            <i class="fa fa-fw fa-print text-blue"></i>Create Return
                                        </a>
                                    </li>                                    
                                </ul>
                            </div>
                        </td>
                    </tr>
                    


                </tbody>
            </table>
            </div>
        </div>
    </div>

</section>